/**
 * @fileoverview POSTWS handler for the "/engagement/async/segment_insights_stats/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryPostWebsocketAdapter } from "../reactQueryFetcherAdapters";
import { engagementAsyncSegmentInsightsStatsAppGroupIdCacheKey } from "./constants";
import type { AsyncSegmentInsightsStatsResponse, RequestSegmentsInsightsStatsProps } from "./types";
import { isSegmentInsightsStats } from "./validators";

export const getEngagementAsyncSegmentInsightsStatsAppGroupId = reactQueryPostWebsocketAdapter(
  engagementAsyncSegmentInsightsStatsAppGroupIdCacheKey,
  async (
    signal,
    { app_group_id: appGroupId, jobToken, ...params }: RequestSegmentsInsightsStatsProps
  ): Promise<AsyncSegmentInsightsStatsResponse> => {
    const payload = {
      job_token: jobToken,
      active_segment: params.active_segment,
      comparable_attributes: params.comparable_attributes,
      estimated: params.estimated,
      segment_ids: params.segment_ids,
      should_refresh_baseline: params.should_refresh_baseline,
      timeout: params.timeout,
    };
    return await fetch(`/engagement/async/segment_insights_stats/${appGroupId}`, "POST", payload, { signal });
  },
  isSegmentInsightsStats
);
